import { motion } from "framer-motion";
import { AVATAR_URL } from "@/components/avatar";

export const TypingIndicator = () => {
  return (
    <div data-testid="typing-indicator" className="flex items-end gap-2.5 justify-start">
      <img
        src={AVATAR_URL}
        alt="Thamelnesan"
        className="h-9 w-9 rounded-full object-cover border-2 border-[#0cb0b5]/50 shrink-0"
      />
      <div className="bg-[#121b29] border border-[#1e293b] rounded-2xl rounded-bl-sm px-5 py-4 flex items-center gap-1.5">
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            className="block h-2 w-2 rounded-full bg-[#0cb0b5]"
            animate={{ y: [0, -5, 0], opacity: [0.4, 1, 0.4] }}
            transition={{
              duration: 0.9,
              repeat: Infinity,
              delay: i * 0.15,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>
    </div>
  );
};
